<template lang="html">
  <div class="home">
    <Header  :showActivity="true"  :showBarrage="false" :showJinbi2="false"></Header>
    <div class="main">
      <div class="content_bg">
        <div class="content">
          <div class="header">
            <div class="avatar">
              <img src="./images/avatar_bg.png" class="avatar_bg"/>
              <img :src="bHeadUrl" class="avatar_img"/>
            </div>
            <div class="txt" v-if="cToBToDayStatus == 1 && showZhuli">
              <p v-html="pageData.head1.p1"></p>
              <p v-html="pageData.head1.p2"></p>
            </div>
            <div class="txt" v-else-if="(cToBToDayStatus == 2 || cToBToDayStatus == 4) && !showZhuli">
              <p  v-html="pageData.head2.p1"></p>
              <p v-if="cToBToDayStatus == 2" v-html="pageData.head2.p2">
              </p>
              <p v-if="cToBToDayStatus == 4" v-html="pageData.head2.p3">
              </p>
            </div>
            <div class="txt" v-else-if="cToBToDayStatus == 5 && !showZhuli">
              <p  v-html="pageData.head3.p1"></p>
              <p v-html="pageData.head3.p2"></p>
            </div>
            <div class="txt other" v-else-if="(cToBToDayStatus == 3 || cToBToDayStatus == 6)&& !showZhuli">
              <p  v-html="pageData.head4.p1"></p>
              <!-- <p>送你一份优质好礼哦</p> -->
            </div>
            <div class="txt other" v-else>
              <p  v-html="pageData.head5.p1"></p>
              <!-- <p>送你一份优质好礼哦</p> -->
            </div>
          </div>
          <div :class="ticketClass">
            <div class="money wenhao" v-if="showZhuli && cToBToDayStatus == 1 && !reward.rewardAmount"></div>
            <div class="money fk" v-if="!showZhuli && !reward.rewardAmount && cToBToDayStatus != 2"  v-html="pageData.ticket.fk"></div>
            <div class="money num" v-if="!showZhuli && !reward.rewardAmount && cToBToDayStatus == 2"  v-html="pageData.ticket.num"></div>
            <div class="money num no-yang" v-if="reward.rewardAmount">{{reward.rewardAmount}}</div>
            <div class="yel-txt" v-if="!reward.rewardAmount && cToBToDayStatus != 2"  v-html="pageData.ticket.yel_txt1"></div>
            <div class="yel-txt" v-if="!reward.rewardAmount && cToBToDayStatus == 2"  v-html="pageData.ticket.yel_txt2"></div>
            <div class="yel-txt yel-name" v-if="reward.rewardName">{{reward.rewardName}}</div>
            <div class="white-txt" v-if="!reward.rewardAmount && cToBToDayStatus != 2" v-html="pageData.ticket.white_txt1"></div>
            <div class="white-txt" v-if="!reward.rewardAmount && cToBToDayStatus == 2" v-html="pageData.ticket.white_txt2"></div>
            <div class="white-txt white-des" v-if="reward.rewardDes">{{reward.rewardDes}}</div>
            <div class="old-other" v-if="reward.rewardAmount" v-html="pageData.ticket.old_other"></div>
          </div>
          <div class="tips"  v-html="pageData.tips"></div>
          <div class="btn help" v-if="cToBToDayStatus == 1 && showZhuli " @click="goHelp" clstag="jr|keycount|sqqxl_20181016|13"><span  v-html="pageData.btnTxt1"></span></div>
          <div class="btn go-download" v-else-if="!showZhuli && (reward.rewardAmount == 888 || cToBToDayStatus == 2)" @click="goToDownload" clstag="jr|keycount|sqqxl_20181016|14"><span  v-html="pageData.btnTxt2"></span></div>
          <div class="btn go-app" v-else-if="!showZhuli && reward.rewardAmount && reward.rewardAmount != 888 && cToBToDayStatus == 4" @click="goToAppReceivePage " clstag="jr|keycount|sqqxl_20181016|15"><span v-html="pageData.btnTxt3"></span></div>
          <div class="btn go-app" v-else-if="!showZhuli && reward.rewardAmount && reward.rewardAmount != 888 && cToBToDayStatus == 5" @click="goToZhuHuiChange" clstag="jr|keycount|sqqxl_20181016|15"><span v-html="pageData.btnTxt4"></span></div>
          <div class="btn go-app" v-else @click="goToZhuHuiChange" clstag="jr|keycount|sqqxl_20181016|16"><span v-html="pageData.btnTxt5"></span></div>
        </div>
      </div>
    </div>
    <div class="rule" id="rule">
      <Rule :showRule="false"></Rule>
    </div>
    <HelpErrorPop :showPop="isShowHelpErrorPop" :helpErrorCode="helpErrorCode" @closePop="closePop"/>
    <ApiErrorPop :showPop="isShowApiErrorPop"  @closePop="closePop"/>
    <NotLoginPop :showPop="isShowNotLoginPop" @closePop="closePop"/>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Rule from "@/components/Rule";
import ApiErrorPop from "@/components/ApiErrorPop"
import NotLoginPop from "@/components/NotLoginPop"
import HelpErrorPop from "@/components/HelpErrorPop"
import { 
  getChannel,
  getCookie,
  getActcode,
  getShareInfo,
  getShareInfoNew,
  getUrlParam,
  goToLoginPage,
  goToLoginPage2,
  goDownLoadPage,
  goMainVenue,
  goAppReceivePage,
  getApiHost,
  canBodyScroll,
  getFengKongUA,
  initShare
} from "@/public/util.js";
import * as api from '@/api';

export default({
  components: {
    Header,
    Rule,
    ApiErrorPop,
    NotLoginPop,
    HelpErrorPop,
  },
  data () {
    return {
      isShowApiErrorPop:false,
      isShowNotLoginPop:false,
      isShowHelpErrorPop:false,
      helpErrorCode:"",
      // isLogined:false,
      channel:getChannel(),
      isFengKong:false,
      showZhuli:false,

      //1 待助力  
      //2 已助力 当前新用户  
      //3 已助力 当前老用户 无奖励
      //4 已助力 当前老用户 有奖励 未领取
      //5 已助力 当前老用户 有奖励 已领取
      cToBToDayStatus:"",
      hitRdInfo:{
        rewardAcount:null,
        rewardName:null,
        rewardDesc:null
      },
      reward:{},
      enBpin:"",
      bHeadUrl:"https://m.360buyimg.com/jrqb/jfs/t1/5157/1/10408/4787/5bcb059eEbec1f817/bca464d8f16a945d.png",
      calHelp:true,
      ticketClass:'ticket',

      pageData:data_source_100001051.friendPage
    }
  },
  mounted () {
    this.initData();
    initShare();
  },
  methods: {
    requestHeadUrlByEnBPin(){
      api.getHeadUrlByEnBPin({
        reqData: JSON.stringify({
          enBpin:this.enBpin
        })
      }).then(res => {
        if(res.resultCode == -1){
          this.showApiErrorPop()
        }else if(res.resultCode == 3){
          this.showNotLoginPop();
        }else{
          if(res.resultData.code == "success" && res.resultData.data){
            this.bHeadUrl = res.resultData.data;
          }else{
            // this.showApiErrorPop();
          }
        }
      })
    },
    initData(){
      let friendData = getUrlParam("friendData");
      friendData = JSON.parse(friendData);
      this.cToBToDayStatus = friendData.cToBToDayStatus;
      if(friendData.hitRdInfo){
        this.reward = Object.assign({},this.reward,friendData.hitRdInfo);
      }
      if(this.cToBToDayStatus == 1){
        this.showZhuli = true;
      }
      if(this.cToBToDayStatus ==2 || this.cToBToDayStatus ==4){
        this.ticketClass = 'ticket unown-ticket'
      }else if(this.cToBToDayStatus ==5){
        this.ticketClass = 'ticket owned-ticket'
      }else{
        this.ticketClass ='ticket'
      }
      this.enBpin = friendData.enBpin;
      if(friendData.bHeadUrl){
        this.bHeadUrl = friendData.bHeadUrl;
      }
      this.requestHeadUrlByEnBPin();
    },
    closePop(popName){
      if(popName == "ApiErrorPop"){
        this.isShowApiErrorPop = false;
      }else if(popName == "NotLoginPop"){
        this.isShowNotLoginPop = false;
      }else if(popName == "HelpErrorPop"){
        this.isShowHelpErrorPop = false;
      }
      canBodyScroll(true);
    },
    showApiErrorPop(){
      this.isShowApiErrorPop = true;
      canBodyScroll(false);
    },
    showNotLoginPop(){
      this.isShowNotLoginPop = true;
      canBodyScroll(false);
    },
    goRedirect(){
      let actCode = getActcode();
      let reqData = {
        actCode:actCode,
        enBpin:this.enBpin
      }
      reqData = JSON.stringify(reqData);
      let str = `reqData=${reqData}`;
      let link = `${getApiHost()}/gw/generic/jrm/redirect/m/fromShareRedirect?${str}`;
      window.location.href = link;
    },
    requestcHelpBAndLottery(riskDeviceParam){
      this.calHelp && api.cHelpBAndLottery({
        reqData: JSON.stringify({
          actCode:getActcode(),
          enBpin:this.enBpin,
          riskDeviceParam:JSON.stringify(riskDeviceParam)
        })
      }).then(res => {
        this.calHelp = true;
        if(res.resultCode == -1){
          this.showApiErrorPop()
        }else if(res.resultCode == 3){
          // this.showNotLoginPop();
          goToLoginPage2(this.enBpin);
        }else{
          // this.isLogined = true;
          let code = res.resultData.code;
          if(code == "helpB_1Step_sucess" || code == "bFull_no_help"){
            this.showZhuli = false;
            this.goRedirect();
            // this.reward = Object.assign({},this.reward,{...res.resultData.data});
          }else if(code == "act_ex" || code == "toDay_helped_B" || code == "toDay_helped_Others" || code == "no_can_help_self"){
            this.isShowHelpErrorPop = true;
            this.helpErrorCode = code;
          }else if(code == "parem_ex"){
            this.isShowApiErrorPop = true;
          }else{
            this.showZhuli = false;
            this.isFengKong = true;
          }
        }
      })
      this.calHelp = false;
    },
    goHelp(){
      getFengKongUA(this.requestcHelpBAndLottery);
    },
    goToDownload(){
      goDownLoadPage();
    },
    goToAppReceivePage(){
      goAppReceivePage();
    },
    goToZhuHuiChange(){
      goMainVenue();
    }
  }
})
</script>

<style lang="scss">
.home{
  // background: #06022D url(./images/bg.jpg) left top no-repeat; 
  // background-size: 100%;
  // height: 100%;
  font-family: PingFangSC-Regular;
  overflow: hidden;
  .main{
    position: relative;
    padding-top: 425px;
    z-index: 999;
    .content_bg{
      width: 750px;
      height: 720px;
      position: relative;
      margin: 0 auto;
      background: url(./images/main_bg.png) center no-repeat;
      background-size: contain;
      .content{
        padding-top:79px;
        .header{
          overflow: hidden;
          // width: 500px;
          margin: 0 auto;
          text-align: center;
          .avatar{
            width: 110px;
            height: 110px;
            // background: url(./images/avatar_bg.png) center no-repeat;
            // background-size: cover;
            float: left;
            margin-right: 40px;
            margin-left: 123px;
            position: relative;
            .avatar_bg{
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 1;
            }
            .avatar_img{
              width: 100px;
              height: 100px;
              border-radius: 100%;
              position: absolute;
              left: 50%;
              top: 50%;
              margin-left: -50px;
              margin-top: -50px;
              z-index: 2;
            }
          }
          .txt{
            width: 360px;
            font-size: 32px;
            color: #fff;
            float: left;
            margin-top: 11px;
            line-height: 48px;
            &.other{
              margin-top: 30px;
            }
            p{
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              text-align: left;
            }
          }
        }
        .ticket{
          width: 626px;
          height: 294px;
          background: url(./images/ticket_bg_own.png) center no-repeat;
          background-size: 100%;
          margin: 16px auto 26px;
          position: relative;
          left: 10px;
          position: relative;
          &.unown-ticket{
            background: url(./images/ticket_bg_unown.png) center no-repeat;
            background-size: 100%;
          }
          &.owned-ticket{
            background: url(./images/ticket_bg_owned.png) center no-repeat;
            background-size: 100%;
          }
          .money{
            position: absolute;
            font-family:FZZZHONGJW--GB1-0;
            font-weight:normal;
            color:rgba(232,1,61,1);
            top: 0;
            font-weight: bold;
            padding-top: 95px;
            &.num{
              width: 160px;
              text-align: center;
              left: 35px;
              font-size: 66px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              &::before{
                content: "¥";
                display: inline;
                font-size: 30px;
                padding-right: 5px;
                vertical-align: baseline;
              }
              &.no-yang{
                &::before{
                  content: "";
                  display: inline;
                  font-size: 30px;
                  padding-right: 5px;
                  vertical-align: baseline;
                }
              }
            }
            &.wenhao{
              height: 165px;
              left: 50px;
              width: 160px;
              text-align: center;
              font-size: 66px;
              background: url(./images/wenhao.png) center center no-repeat;
              background-size: 39px 60px;
              position: relative;
              &::before{
                content: "¥";
                display: block;
                position: absolute;
                font-size: 30px;
                padding-right: 70px;
                top: 132px;
                right: 39px;
              }
            }
            &.fk{
              left: 40px;
              font-size: 66px;
              top: 10px;
              width: 160px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
          }
          .yel-txt{
            font-size:42px;
            font-family:PingFangSC-Semibold;
            font-weight:600;
            color:rgba(255,237,0,1);
            position: absolute;
            top:88px;
            left: 250px;
            width: 300px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            &.yel-name{
              top:78px;
            }
          }
          .white-txt{
            width: 300px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            font-size:28px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(255,255,255,1);
            position: absolute;
            bottom:110px;
            left: 250px;
            &.white-des{
              bottom:115px;
            }
          }
          .old-other{
            font-size:20px;
            font-family:PingFangSC-Regular;
            color:rgba(255,255,255,0.4);
            position: absolute;
            bottom:75px;
            left: 250px;
            width: 300px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
        .tips{
          width: 620px;
          margin:10px auto 0;
          font-size: 24px;
          color: #fff;
          text-align: center;
          opacity: 0.5;
          // overflow: hidden;
          // text-overflow:ellipsis;
          // white-space: nowrap;
        }
        .btn{
          width: 600px;
          height: 100px;
          margin: 20px auto 90px;
          text-align: center;
          background: url(./images/btn_new.png) center no-repeat;
          background-size: 100%;
          box-shadow: 0 11px 27px rgba(0,0,0,0.43);
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          span{
            background-image: -webkit-gradient(linear, 0 0, right 0, from(rgba(172, 25, 22, 1)), to(rgba(107, 13, 12, 1)));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-size: 36px;
            line-height: 100px;
            font-weight: bold;
          }
          // &.help{
          //   background: url(./images/btn_help.png) center no-repeat;
          //   background-size: 100%;
          // }
          // &.not-login{
          //   background: url(./images/btn_click.png) center no-repeat;
          //   background-size: 100%;
          // }
          // &.go-download{
          //   background: url(./images/btn_app.png) center no-repeat;
          //   background-size: 100%;
          // }
          // &.go-app{
          //   background: url(./images/btn_1111.png) center no-repeat;
          //   background-size: 100%;
          // }
        }
      }
    }
    
  }
  .rule{
    // margin-top:42px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/friend/App.vue